<template>
  <v-app>
    <v-main>
      <v-container fluid>
        <v-card outlined max-height="800px" class="rounded-xl">
          <v-card-title>
            <h6 class="text-sm-h4 text-h6 mx-auto">
              Подтверждение электронных учебных курсов
            </h6>
          </v-card-title>
        </v-card>
        <v-row class="mt-4 fill-height">
          <v-col cols="12">
            <CardListTechMaps/>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
    import CardListTechMaps from "./Cards/CardListTechMaps";
    import {mapActions, mapState} from "vuex";

    export default {
        name: "DashboardConfirmCommissionEuk",
        components: {
           CardListTechMaps
        },
        data: () => ({

        }),
        mounted() {
            this.getListEducationalPrograms();
            this.getCountTechMaps();
        },
        computed: {
            ...mapState({
            }),
        },
        methods: {
            ...mapActions({
                getListEducationalPrograms: 'studyEstEukTechMapAdditData/getListEducationalPrograms',
                getCountTechMaps: 'studyEstEukTechMapAdditData/getCountTechMaps'
            }),
        }
    }
</script>

<style scoped>

</style>